export const SelectItemsModalElementsIdsEnum = {
    SELECT_MODAL_STEP2_PROGRESSBAR: 'selectModalStep2Progressbar',
    SELECT_MODAL_STEP2_HEADER: 'selectModalStep2Header',
    SELECT_MODAL_STEP2_CLEAR_BUTTON: 'selectModalStep2Step2ClearButton',
    SELECT_MODAL_STEP2_INPUT_FIELD: 'selectModalStep2Step2InputField',
} as const;

export type SelectItemsModalElementsIdsType =
    (typeof SelectItemsModalElementsIdsEnum)[keyof typeof SelectItemsModalElementsIdsEnum];
